import Link from 'next/link';
import { usePathname } from 'next/navigation';

import DropdownList from './ui/dropdownlist';

export type menuItem = {
  title: string;
  href?: string;
  items?: menuItem[];
  isActive?: boolean;
};

type SecondaryMenuProps = {
  menuItems: menuItem[];
};

const SecondaryMenu = ({ menuItems }: SecondaryMenuProps) => {
  const pathName = usePathname();
  const activeItem = menuItems.find((item) => {
    if (item.items) {
      item.items.forEach((subItem) => (subItem.isActive = false));
      if (item.items.some((subItem) => subItem.href === pathName)) {
        item.items.forEach((subItem) => {
          if (subItem.href === pathName) subItem.isActive = true;
        });
        return true;
      }
    }
    return item.href === pathName;
  }) || { title: '', href: '', isActive: false };

  return (
    <section className="top-[80px] z-20 w-full shadow-sm fixed bg-white pt-5 border-t-2">
      <ul className="flex lg:max-w-8xl mx-auto flex-row justify-between gap-x-4 px-1 text-sm">
        {menuItems.map((item) => {
          if (!item.items) {
            return (
              <li key={item.title} className="relative pb-3">
                <Link href={item.href} className="cursor-pointer py-3">
                  <span
                    className={
                      activeItem && activeItem.title === item.title
                        ? 'font-semibold'
                        : ''
                    }
                  >
                    {item.title}
                  </span>
                  {activeItem && activeItem.title === item.title && (
                    <>
                      <div className="absolute left-0 right-0 bottom-0 h-[2px] bg-primary rounded"></div>
                      <div className="absolute left-1/2 transform -translate-x-1/2 bottom-[-8px] w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-t-[8px] border-t-primary"></div>
                    </>
                  )}
                </Link>
              </li>
            );
          } else {
            return (
              <li key={item.title} className="relative pb-3 cursor-pointer">
                <DropdownList
                  items={item.items}
                  title={item.title}
                  selectedItem={activeItem?.items?.find(
                    (subItem: menuItem) => subItem.isActive === true
                  )}
                />
                {activeItem && activeItem.title === item.title && (
                  <>
                    <div className="absolute left-0 right-0 bottom-0 h-[2px] bg-primary rounded"></div>
                    <div className="absolute left-1/2 transform -translate-x-1/2 bottom-[-8px] w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-t-[8px] border-t-primary"></div>
                  </>
                )}
              </li>
            );
          }
        })}
      </ul>
    </section>
  );
};

export default SecondaryMenu;
